import styled from 'styled-components';

import { ULList } from '~/src/components/Typography';

export const FeaturesListContainer = styled(ULList)`
  --icon-color: #3771ff;
`;
